
import { updateAppConfig } from '#app/config'
import { defuFn } from 'defu'

const inlineConfig = {
  "buildId": "21535c71f7bde697bb02b431d09c1f4181de183c",
  "nuxt": {
    "buildId": "db9e970d-7589-42d5-a68e-99fb5aed26a6"
  }
}

// Vite - webpack is handled directly in #app/config
if (import.meta.hot) {
  import.meta.hot.accept((newModule) => {
    updateAppConfig(newModule.default)
  })
}



export default /*@__PURE__*/ defuFn(inlineConfig)
